import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import LandingPage from '@/pages/LandingPage';
import GoalInputPage from '@/pages/GoalInputPage';
import QuestionsPage from '@/pages/QuestionsPage';
import EmailCapturePage from '@/pages/EmailCapturePage';
import ReportPage from '@/pages/ReportPage';
import ReportViewPage from '@/pages/ReportViewPage';

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/goals" element={<GoalInputPage />} />
            <Route path="/questions" element={<QuestionsPage />} />
            <Route path="/email" element={<EmailCapturePage />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/report/:userId" element={<ReportViewPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
